import { useEffect } from 'react'
import { TAG_MULTIPATH_CTA } from '../analytics/analytics.tagids.constants'
import { PUB_TAG } from '../analytics/PublisherTagsService'
import useConfigureAndSendTag from '../analytics/useConfigureAndSendTag'
import useTimeout from '../utils/useTimeout'

export default function usePublisherBarreCategorieTag(categoryId) {
  const configureAndSendTag = useConfigureAndSendTag()
  const [setPublisherTagTimeout, clearPublisherTagTimeout] = useTimeout(1000)

  useEffect(() => {
    setPublisherTagTimeout(() =>
      configureAndSendTag({
        type: TAG_MULTIPATH_CTA,
        tagInfo: { tag: PUB_TAG.PUB_AFFICHAGE_BARRECATEGORIE, catId: categoryId },
        isImpression: true
      })
    )
    return clearPublisherTagTimeout
  }, [categoryId])
}
